/* Contact form — static clone: no backend, show confirmation locally */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('contact-form');
    var success = document.getElementById('contact-success');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('contact-email');
      if (email && !email.value.trim()) {
        email.focus();
        email.setCustomValidity('Veuillez remplir ce champ.');
        email.reportValidity();
        email.setCustomValidity('');
        return;
      }
      form.reset();
      if (success) success.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
